(function() {
    'use strict';

    angular
        .module('publicGatewayApp')
        .controller('PublicProfileDeleteController',PublicProfileDeleteController);

    PublicProfileDeleteController.$inject = ['$uibModalInstance', 'entity', 'PublicProfile'];

    function PublicProfileDeleteController($uibModalInstance, entity, PublicProfile) {
        var vm = this;

        vm.publicProfile = entity;
        vm.clear = clear;
        vm.confirmDelete = confirmDelete;

        function clear () {
            $uibModalInstance.dismiss('cancel');
        }

        function confirmDelete (id) {
            PublicProfile.delete({id: id},
                function () {
                    $uibModalInstance.close(true);
                });
        }
    }
})();
